/**
 * Picks v2 or v1 of the Tapping Basics page based on the redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import OnboardingDataPage   from './OnboardingDataPage';
import OnboardingDataPageV2 from './v2/OnboardingDataPageV2';

export default function OnboardingDataPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? OnboardingDataPageV2 : OnboardingDataPage;
  return <Component {...props} />;
}
